// Base URL
let baseUrl: string = 'https://panel.fesalpg.com';

// Api URL
let apiUrl: string = baseUrl + '/api';

// Component Populates
let componentPopulates = "populate[0]=components&populate[1]=components.products&populate[2]=components.product_categories&populate[3]=components.account_numbers&populate[4]=components.trainings&populate[5]=components.banner&populate[6]=components.image";

export default {
    baseUrl,
    apiUrl,
    componentPopulates
};